import { Editor, Element, Transforms } from 'slate'
import { useSlate } from 'slate-react'
import React from 'react'

import EditorIcon from '../EditorIcon'

const isActive = (editor, name, value) => {
  const { selection } = editor
  if (!selection) return false

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: n => !Editor.isEditor(n) && Element.isElement(n) && n[name] === value
    })
  )

  return !!match
}

const toggle = (editor, name, value) => {
  const active = isActive(editor, name, value)
  Transforms.setNodes(editor, {
    [name]: !active ? value : undefined
  })
}

const ToggleIcon = ({ icon, name, value, ...props }) => {
  const editor = useSlate()
  const active = isActive(editor, name, value)

  return <EditorIcon onClick={() => toggle(editor, name, value)} icon={icon} active={active} {...props} />
}

const BlockMarkerPlugin = {
  isActive,
  toggle,
  ToggleIcon
}

export default BlockMarkerPlugin
